const e=(e,c=!0)=>e.reduce(((e,o)=>({...e,[o]:c})),{});export{e as toObjectKeys};
